import React from 'react';
import { matchPath } from 'react-router';
import Loadable from 'react-loadable';
import { get } from 'lodash';
import { Route, Switch } from 'react-router-dom';
import { pages } from '../constants/routes';
import PageLayout from '../layouts/PageLayout';

const TransferPageContainer = Loadable({
  loader: () => import('../containers/transfer'),
  loading: () => null,
});

export default function (store: any, props: any) {
  const { match } = props;
  const pageParamsOrder = matchPath(match.url, {
    exact: true,
    path: pages.transferOrder(':email', ':orderId', ':eventId'),
    strict: false,
  });
  const pageParamsTicket = matchPath(match.url, {
    exact: true,
    path: pages.transferTicket(':email', ':orderId', ':eventId', ':eventZoneId', ':seatGroupId', ':seatId'),
    strict: false,
  });
  const extendedProps = {
    ...props,
    customerEmail: get(pageParamsOrder, 'params.email') || get(pageParamsTicket, 'params.email'),
    eventId: get(pageParamsOrder, 'params.eventId') || get(pageParamsTicket, 'params.eventId'),
    eventZoneId: get(pageParamsTicket, 'params.eventZoneId'),
    orderId: get(pageParamsOrder, 'params.orderId') || get(pageParamsTicket, 'params.orderId'),
    seatGroupId: get(pageParamsTicket, 'params.seatGroupId'),
    seatId: get(pageParamsTicket, 'params.seatId'),
  };

  return (
    <Switch>
      <PageLayout>
        <Route
          path={ match.url }
          render={ () => <TransferPageContainer { ...store } { ...extendedProps } /> }
        />
      </PageLayout>
    </Switch>
  );
}
